import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFPlainText } from "../../../Shared/NewForms/NFPlainText";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { AmountHelper } from "../../../../helpers/AmountHelper";
import { VatTypeEnum } from "../../../../enums/VatTypeEnum";
import { NFLookupVatType } from "../../../Shared/NewForms/NFLookupVatType";
import { useTranslation } from "react-i18next";

export const ReturnOfGoodsFromCustomersDetailProducts = () => {
    const tableName = "products";
    const { setValue, getValues } = useFormContext();
    const { t } = useTranslation();

    const handleVatTypeChanged = (newVatType: VatTypeEnum, index: number) => {
        setValue(
            `${tableName}.${index}.vatAmount`,
            AmountHelper.getVatAmount(
                newVatType,
                getValues(`${tableName}.${index}.amount`),
                getValues("priceIncludesVat")
            )
        );
    };

    const handleQuantityChanged = (newQuantity: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            newQuantity,
            getValues(`${tableName}.${index}.price`),
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    const handlePriceChanged = (newPrice: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            getValues(`${tableName}.${index}.quantity`),
            newPrice,
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"returnOfGoodsFromCustomerProducts"}>
                <NFLookupProduct
                    fieldName={"productId"}
                    title={t("Product")}
                    width={200}
                />
                <NFLookupUnit
                    title={t("Unit")}
                    fieldName="unitId"
                    width={200}
                />
                <NFIntInput
                    fieldName={"quantity"}
                    title={t("Quantity")}
                    width={100}
                    onValueChanged={handleQuantityChanged}
                />
                <NFIntInput
                    fieldName={"price"}
                    title={t("Price")}
                    width={100}
                    onValueChanged={handlePriceChanged}
                />
                <NFIntInput
                    fieldName={"amount"}
                    title={t("Amount")}
                    width={100}
                />
                <NFLookupVatType
                    title={t("VATType")}
                    fieldName={"vatType"}
                    width={200}
                />
                <NFIntInput
                    fieldName={"vatRate"}
                    title={t("VATRate")}
                    width={100}
                    //   onValueChanged={handleVatRateChange}
                />
                <NFIntInput
                    fieldName={"vatAmount"}
                    title={t("VATAmount")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"amountWithVat"}
                    title={t("AmountWithVAT")}
                    width={100}
                />
            </NFormTable>
        </>
    );
};
